import type { AccountId } from "@repo/app-types/entities/account";
import type {
  CustomerCallActivity,
  PerformanceCustomerDetail,
  PerformanceCustomerRow,
} from "@repo/app-types/entities/performanceCustomer";
import { api } from "../redux.js";

const customerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    customers: builder.infiniteQuery<
      {
        customers: readonly PerformanceCustomerRow[];
        nextCursor: string | null;
      },
      { search: string },
      string | null,
      {
        data: { customers: readonly PerformanceCustomerRow[] };
        next_cursor: string | null;
      }
    >({
      infiniteQueryOptions: {
        initialPageParam: null,
        getPreviousPageParam: () => null,
        getNextPageParam: (lastPage) => lastPage.nextCursor,
      },
      query: ({ queryArg, pageParam }) => ({
        method: "POST",
        url: "/performance/customers",
        body: { search: queryArg.search, cursor: pageParam },
      }),
      transformResponse: (response) => ({
        customers: response.data.customers,
        nextCursor: response.next_cursor,
      }),
    }),
    customerDetail: builder.query<
      PerformanceCustomerDetail,
      AccountId,
      { data: PerformanceCustomerDetail }
    >({
      query: (accountId) => ({
        method: "GET",
        url: `/performance/customers/${accountId}`,
      }),
      transformResponse: (response) => response.data,
    }),
    customerTimeline: builder.infiniteQuery<
      { calls: readonly CustomerCallActivity[]; nextCursor: string | null },
      AccountId,
      string | null,
      {
        data: { calls: readonly CustomerCallActivity[] };
        next_cursor: string | null;
      }
    >({
      infiniteQueryOptions: {
        initialPageParam: null,
        getPreviousPageParam: () => null,
        getNextPageParam: (lastPage) => lastPage.nextCursor,
      },
      query: ({ queryArg: accountId, pageParam }) => ({
        method: "GET",
        url: `/performance/customers/${accountId}/timeline`,
        params: { cursor: pageParam ?? undefined },
      }),
      transformResponse: (response) => ({
        calls: response.data.calls,
        nextCursor: response.next_cursor,
      }),
    }),
  }),
});

export const {
  useCustomersInfiniteQuery,
  useCustomerDetailQuery,
  useCustomerTimelineInfiniteQuery,
} = customerApi;
